import React from 'react';

const CoreFeatures = () => {
  const features = [
    {
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      title: 'Deep-Learning Market Scanner',
      description: 'Proprietary LangGraph agents analyze market data in real-time. Advanced NLP processes natural language queries across millions of data points.',
      benefit: 'Institutional-grade analysis'
    },
    {
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
        </svg>
      ),
      title: 'Multi-Channel Notification Engine',
      description: 'Get critical signals where you are—Dashboard or Email. Custom agentic workflows trigger alerts based on proprietary algorithms.',
      benefit: 'Real-time intelligence delivery'
    },
    {
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
      title: 'Portfolio Tracking',
      description: 'Real-time portfolio analytics powered by custom data processing pipelines. AI-powered risk analysis with institutional-grade calculations.',
      benefit: 'Advanced risk management'
    },
  ];

  return (
    <section id="features" className="bg-white py-12 md:py-16 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

        {/* Section Header */}
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-[#222425] mb-6 leading-tight tracking-tight">
            Everything You Need to Invest Smarter
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto font-light">
            Powerful features designed for both beginners and experienced investors
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl p-10 border border-gray-100 hover:border-[#00DA76]/30 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 flex flex-col"
            >
              {/* Icon */}
              <div className="w-16 h-16 bg-gradient-to-br from-[#00DA76]/10 to-emerald-500/10 rounded-2xl flex items-center justify-center text-[#00DA76] mb-6 group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                <div className="w-8 h-8">
                  {React.cloneElement(feature.icon, {
                    className: "w-full h-full"
                  })}
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 flex flex-col">
                <h3 className="text-2xl font-bold text-[#222425] mb-4 group-hover:text-[#00DA76] transition-colors duration-300">
                  {feature.title}
                </h3>

                <p className="text-gray-600 leading-relaxed mb-6 text-base font-light flex-1">
                  {feature.description}
                </p>

                <div className="flex items-center gap-2 text-[#00DA76] font-medium text-sm">
                  <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>{feature.benefit}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default CoreFeatures;
